import Component from '../core/Component'
import keycode from 'keycode'
import { enableScroll, disableScroll } from '../services/Scroll'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    OPEN: 'is-open'
}

export default class Nav extends Component {
    constructor(element) {
        super(element)

        this.parentNode = this.element.parentNode
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        this.element.addEventListener(support.transitionEnd, event => {
            if (event.propertyName === 'transform' && this.element === event.target && !this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
    }

    destroy() {
        this.close()
        document.removeEventListener('keydown', this.handleKeydown)
    }


    handleClick = event => {
        if (!this.element.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            this.close()
        }
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        this.element.classList.remove(STATES.OPEN)
        document.removeEventListener('keydown', this.handleKeydown)
        document.documentElement.classList.remove('is-nav-open')
        enableScroll()
        EventBus.emit('nav-close')
    }

    open() {
        disableScroll()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.documentElement.classList.add('is-nav-open')
        document.addEventListener('keydown', this.handleKeydown)
        EventBus.emit('nav-open')

        setTimeout(() => {
            this.element.classList.add(STATES.OPEN)
        }, 500)
    }


}